module.exports = __webpack_public_path__ + "34809b77d0195ed6cc822eba341955b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/bg_02.png
// module id = 940
// module chunks = 3